import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ChequeModal } from './ChequeModal';
import { BankTransferModal } from './BankTransferModal';

function AlternativePaymentButtons() {
  const [showChequeModal, setShowChequeModal] = useState(false);
  const [showBankTransferModal, setShowBankTransferModal] = useState(false);

  const handleCryptoClick = () => {
    window.open('https://helpyateem.org/donate-crypto/', '_blank');
  };

  return (
    <>
      {/* Alternative Payment Methods */}
      <div className="mb-4 mt-4">
        <div className="d-flex gap-3 justify-content-start align-items-center flex-wrap">
          <span className="text-muted fw-bold">Other ways to donate:</span>
          <div className="d-flex gap-2">
            <Button
              className="text-white border-0 px-3 py-2 fw-medium"
              style={{ backgroundColor: '#1e3a5f', fontSize: '14px' }}
              onClick={() => setShowChequeModal(true)}
            >
              Cheque
            </Button>
            <Button
              className="text-white border-0 px-3 py-2 fw-medium"
              style={{ backgroundColor: '#1e3a5f', fontSize: '14px' }}
              onClick={() => setShowBankTransferModal(true)}
            >
              Bank Transfer
            </Button>
            <Button
              className="text-white border-0 px-3 py-2 fw-medium"
              style={{ backgroundColor: '#1e3a5f', fontSize: '14px' }}
              onClick={handleCryptoClick}
            >
              Crypto
            </Button>
          </div>
        </div>
      </div>

      {/* Modals */}
      <ChequeModal 
        show={showChequeModal} 
        onHide={() => setShowChequeModal(false)} 
      />
      <BankTransferModal 
        show={showBankTransferModal} 
        onHide={() => setShowBankTransferModal(false)} 
      />
    </>
  );
}

export { AlternativePaymentButtons }; 